import { CardLayouts } from '@loyalty/editor-components';
import type { TFunction } from 'i18next';

export type CardLayoutTemplateSelectOption = { name: string; id: CardLayouts };

/** Shared i18n keys: `editor.card-layout.label`, `.default`, `.legacy`, `.button-only` */
export function getCardLayoutTemplateSelectOptions(t: TFunction): CardLayoutTemplateSelectOption[] {
  return [
    { name: t('editor.card-layout.default'), id: CardLayouts.DEFAULT },
    { name: t('editor.card-layout.legacy'), id: CardLayouts.LEGACY },
    { name: t('editor.card-layout.button-only'), id: CardLayouts.BUTTON_ONLY },
  ];
}
